import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'

/**
 * @method apiRequestOTP
 * @method apiValidateContactNumber
 * @method apiDeviceLogin
 * @method apiLogin
 * @method apiLogout
 * @method actionGetConsent
 * @method actionGetUnConsent
 * @method actionPostConsent
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },

  /**
   * Request OTP
   * @param {Object} authRequestOTPParams AuthRequestOTPModel.getParams() /service/config/AuthConfigModel.js
   */
  apiRequestOTP: function (authRequestOTPParams) {
    var url = this.config().bzbUrlService + '/auth/otp'
    return BzbsApi.connectBzbsGet(url, null, authRequestOTPParams)
  },

  apiValidateContactNumber: function (contactNumber) {
    var param = {
      contact_number: contactNumber,
    }
    var url = Vue.bzbsConfig.bzbModuleUrl + '/auth/validate_contact_number'
    return BzbsApi.connectBzbsPostAppId(url, null, param)
  },
  apiValidateContactNumberSSO: function (contactNumber) {
    var param = {
      contact_number: contactNumber,
    }
    var url = Vue.bzbsConfig.bzbModuleUrl + '/auth/validate_contact_number_v2'
    return BzbsApi.connectBzbsPostAppId(url, null, param)
  },
  apiDeviceLogin: function (data) {
    var param = {
      uuid: data.contactNumber,
      contact_number: data.contactNumber,
      refcode: data.refcode,
      otp: data.otp,
      app_id: data.appId,
    }
    var url = Vue.bzbsConfig.bzbUrlService + '/auth/device_login'
    return BzbsApi.connectBzbsPostAppId(url, null, param)
  },

  apiConfirmOTP: function (params) {
    var data = {}
    var strUrl
    if (params.contact_number) {
      strUrl =
        this.config().bzbUrlService +
        '/auth/validate_otp?otp=' +
        params.otp +
        '&refcode=' +
        params.refcode +
        '&contact_number=' +
        params.contact_number +
        '&use=' +
        params.use +
        '&channel=' +
        params.channel +
        '&app_id=' +
        params.app_id
    } else {
      strUrl =
        this.config().bzbUrlService +
        '/auth/validate_otp?otp=' +
        params.otp +
        '&refcode=' +
        params.refcode +
        '&use=' +
        params.use +
        '&channel=' +
        params.channel +
        '&app_id=' +
        params.app_id
    }

    console.log('strUrl::: ', strUrl)
    return BzbsApi.connectBzbsPost(strUrl, null, data)
  },
  /**
   * @param {String} username
   * @param {String} password
   * @param {String} strUUID
   * @param {String} strDeviceToken
   * @param {String} strClientVersion
   * @param {Boolean} isDeviceNotiEnable
   */
  apiLogin: function (
    username,
    password,
    strUUID,
    strDeviceToken,
    strClientVersion,
    isDeviceNotiEnable,
  ) {
    var params = {
      username: username,
      password: password,
      uuid: strUUID,
      app_id: this.config().client_id,
      os: 'web',
      platform: 'web',
      mac_address: strUUID,
      device_noti_enable: isDeviceNotiEnable,
      client_version: strClientVersion,
      device_token: strDeviceToken,
    }

    var url = this.config().bzbUrlService + '/auth/bzbs_login'
    return BzbsApi.connectBzbsPost(url, null, params)
  },

  /**
   * @param {String} strBzbsToken
   * @param {String} strFBToken
   * @param {String} strUUID
   */
  apiLogout: function (strBzbsToken, strFBToken, strUUID) {
    var params = {
      uuid: strUUID,
      access_token: strFBToken,
    }

    var url = this.config().bzbUrlService + '/auth/logout'
    return BzbsApi.connectBzbsPost(url, strBzbsToken, params)
  },
  /**
   * @param {String} lineIdToken
   */
  apilinedirectlogin: function (params, enable) {
    var url = ''
    if (params.id_token && typeof params.id_token == 'object') {
      params.id_token = params.id_token[0]
    }
    if (enable == true || enable == 'true') {
      url = Vue.bzbsConfig.bzbUrlService + '/auth/line_login'
    } else {
      url = Vue.bzbsConfig.bzbUrlService + '/auth/line_direct_login?'
    }
    return BzbsApi.connectBzbsPost(url, null, params)
  },
  apilineotpdirectlogin: function (params, token) {
    var url = ''

    url = Vue.bzbsConfig.bzbUrlService + '/auth/line_login'

    if (params.id_token && typeof params.id_token == 'object') {
      params.id_token = params.id_token[0]
    }

    return BzbsApi.connectBzbsPost(url, token, params)
  },
  actionGetLineInfo: function (params) {
    var url =
      Vue.bzbsConfig.bzbModuleUrl + '/line/landing_info?appId=' + params.appId

    return BzbsApi.connectBzbsGet(url, null, null)
  },
  apicrmpluscustomer: function (params, token) {
    var url = Vue.bzbsConfig.bzbModuleUrl + '/crmpluscustomer/store'

    return BzbsApi.connectBzbsGet(url, token, params)
  },
  actionGetConsent: function (params, token) {
    var url = Vue.bzbsConfig.bzbUrlService + '/consent'

    return BzbsApi.connectBzbsGet(url, token, params)
  },
  actionGetUnConsent: function (token) {
    var params = {}
    var url = Vue.bzbsConfig.bzbModuleUrl + '/crmpluscustomer/check_unconsent'

    return BzbsApi.connectBzbsGet(url, token, params)
  },
  actionPostConsent: function (params, token) {
    var url = Vue.bzbsConfig.bzbUrlService + '/consent'
    return BzbsApi.connectBzbsPost(url, token, params)
  },
  actionGetMarketing: function (token) {
    var url = Vue.bzbsConfig.bzbUrlService + '/consent'
    return BzbsApi.connectBzbsGet(url, token, null)
  },
}
